"use strict";

require("core-js/modules/es6.string.link");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _gatsby = require("gatsby");

var Banner = function Banner(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "full-width-image margin-top-0",
      style: {
        backgroundImage: "url(".concat(!!props.data.image.childImageSharp ? props.data.image.childImageSharp.fluid.src : props.data.image, ")"),
        backgroundPosition: "center center",
        padding: "25px 0px",
        position: "relative",
        width: "auto",
        height: "auto"
      }
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "background-overlay",
      style: {
        backgroundColor: "".concat(props.data.overlay.backgroundColor),
        opacity: "".concat(props.data.overlay.opacity)
      }
    }),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      style: {
        display: 'flex',
        lineHeight: '1',
        justifyContent: 'space-around',
        alignItems: 'center',
        flexDirection: 'column',
        zIndex: 1
      }
    },
    /*#__PURE__*/
    _react["default"].createElement("h1", {
      className: "is-size-5-mobile is-size-4-tablet is-size-3-widescreen",
      style: {
        color: 'white',
        textAlign: 'center'
      }
    }, props.data.title), props.data.text !== null ?
    /*#__PURE__*/
    _react["default"].createElement("h1", {
      className: "is-size-10",
      style: {
        color: 'white',
        textAlign: 'center',
        padding: '0',
        margin: '0'
      }
    }, props.data.text) : null, props.data.button !== null ?
    /*#__PURE__*/
    _react["default"].createElement("div", {
      style: {
        textAlign: "".concat(props.data.button.align),
        paddingTop: '1rem'
      }
    },
    /*#__PURE__*/
    _react["default"].createElement(_gatsby.Link, {
      to: "".concat(props.langKey === "en" ? "" : props.langKey).concat(props.data.button.link),
      className: "button is-dark is-small"
    }, props.data.button.value)) : null))
  );
};

var _default = Banner;
exports["default"] = _default;